import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { connect, useStore } from "react-redux";

import { faCog } from "@fortawesome/pro-light-svg-icons";

import { THEME, LANG } from "../../enums/global.enum";
import { MainLayoutSelectOption } from "types/generic";

import MainLayoutSelect from "../generic/ mainlayoutselector";

import { switchTheme } from "utils/functions";
import {
    updateIsOpenPreferencesModal,
    updateLanguage,
    updateTheme,
} from "redux/reducers/global/actions";
import { useIntl } from "react-intl";
import { AVAILABLE_LANGUAGES, getEnvVariable } from "utils/environment";
import { postUserPreferences } from "services/requests/v1/user";
import { Dispatch } from "redux";
import { setUserPreferences } from "redux/reducers/preferences/actions";

type PreferencesMenuType = {
    updatePreferences: (
        language: string,
        dateFormat: string,
        timeFormat: string,
        weekStartDay: string
    ) => void;
};

const PreferencesMenu = ({ updatePreferences }: PreferencesMenuType) => {
    const [isBoxOpen, setIsBoxOpen] = useState<boolean>(false);

    const intl = useIntl();

    const [languages, setLanguages] =
        useState<MainLayoutSelectOption<string>[]>();
    const [selectedLanguage, setSelectedLanguage] = useState<LANG>();

    const [themes, setThemes] = useState<MainLayoutSelectOption<THEME>[]>();
    const [selectedTheme, setSelectedTheme] = useState<THEME>();

    const store = useStore();
    const language = store.getState().app.language;
    const theme = store.getState().app.theme;

    useEffect(() => {
        const availableLanguages =
            getEnvVariable(AVAILABLE_LANGUAGES).split(",");

        setThemes(
            Object.entries(THEME).map((x) => {
                x[0] = intl.formatMessage({ id: `app.Theme.${x[1]}` });
                return { label: x[0], value: x[1] };
            })
        );

        const languages = availableLanguages.map((language) => {
            const label = intl.formatMessage({
                id: `app.Language.${language}`,
            });

            return { label, value: language };
        });

        setLanguages(
            languages.length && languages[0].value
                ? languages
                : [
                      {
                          label: intl.formatMessage({ id: `app.Language.en` }),
                          value: "en",
                      },
                  ]
        );
    }, []);

    useEffect(() => {
        language && setSelectedLanguage(language);
    }, [language]);

    useEffect(() => {
        theme && setSelectedTheme(theme);
    }, [theme]);

    const setCurrentTheme = (entry: THEME) => {
        setSelectedTheme(entry);
        switchTheme(entry);
        store.dispatch(updateTheme(entry));
    };

    const setCurrentLanguage = (entry: LANG) => {
        setSelectedLanguage(entry);
        store.dispatch(updateLanguage(entry));
    };

    const generateOptionBoxClass = () => {
        if (isBoxOpen) {
            return "c-goaigua-preferences-menu";
        } else {
            return "c-goaigua-preferences-menu --hidden-menu";
        }
    };

    const changeVisibilityPreferencesModal = () => {
        store.dispatch(updateIsOpenPreferencesModal(true));
    };

    return (
        <>
            {isBoxOpen && (
                <div
                    className="c-goaigua-preferences-menu__dropdown-background"
                    onClick={() => setIsBoxOpen(false)}
                ></div>
            )}
            <div className={generateOptionBoxClass()} tabIndex={0}>
                <div onClick={() => setIsBoxOpen(!isBoxOpen)}>
                    <FontAwesomeIcon icon={faCog} />
                </div>
                <div
                    className="c-goaigua-preferences-menu__dropdown-box"
                    tabIndex={0}
                >
                    <h4>
                        {intl.formatMessage({
                            id: "app.components.preferences.general",
                        })}
                    </h4>
                    <label>
                        {intl.formatMessage({
                            id: "app.Language",
                        })}
                    </label>
                    <div className="c-goaigua-preferences-menu__dropdown">
                        <MainLayoutSelect
                            options={languages as any}
                            selectedOption={selectedLanguage}
                            setSelectedOption={(value: LANG) => {
                                setCurrentLanguage(value);
                                setIsBoxOpen(!isBoxOpen);
                                postUserPreferences(
                                    store.getState().preferences.timeDateFormat
                                        .dateFormat,
                                    value,
                                    store.getState().preferences.timeDateFormat
                                        .timeFormat,
                                    store.getState().preferences.timeDateFormat
                                        .weekStartDay
                                ).then((res) => {
                                    updatePreferences(
                                        res.data.language,
                                        res.data.dateFormat,
                                        res.data.timeFormat,
                                        res.data.weekStartDay
                                    );
                                });
                            }}
                            placeholder={intl.formatMessage({
                                id: `app.Language.${language}`,
                            })}
                        />
                    </div>

                    <label>
                        {intl.formatMessage({
                            id: "app.components.preferences.theme",
                        })}
                    </label>
                    <div className="c-goaigua-preferences-menu__dropdown">
                        <MainLayoutSelect
                            options={themes}
                            selectedOption={selectedTheme}
                            setSelectedOption={(value: THEME) =>
                                setCurrentTheme(value)
                            }
                            placeholder={intl.formatMessage({
                                id: `app.Theme.${theme}`,
                            })}
                        />
                    </div>
                    <div
                        className={
                            "c-goaigua-preferences-menu__dropdown-box__division-line"
                        }
                    />
                    <div
                        className="c-goaigua-preferences-menu_options"
                        onClick={() => changeVisibilityPreferencesModal()}
                        style={{
                            fontSize: "0.75em",
                        }}
                    >
                        {intl.formatMessage({
                            id: "app.components.preferences.moreOptions",
                        })}
                    </div>
                </div>
                <div
                    className="c-goaigua-preferences-menu__dropdown-triangle"
                    // {...boxEventHandlers}
                    tabIndex={0}
                />
            </div>
        </>
    );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        updatePreferences: (
            language: string,
            dateFormat: string,
            timeFormat: string,
            weekStartDay: string
        ) =>
            dispatch(
                setUserPreferences(
                    language,
                    dateFormat,
                    timeFormat,
                    weekStartDay
                )
            ),
    };
};
export default connect(null, mapDispatchToProps)(PreferencesMenu);
